/*
 * /simulador
 */
export const SIMULATOR_URL = '/simulador'

/*
 * /rede-credenciada
 */
export const ACCREDITED_ESTABILISHMENTS_URL = '/rede-credenciada/prestadores'
/*
 * external links
 */
export const HOME_URL = 'https://alice.com.br'

export const WEBFLOW_ACCREDITED_ESTABILISHMENTS_URL =
  'https://www.alice.com.br/rede-credenciada'

/*
 * navegacao principal do header
 */
export const FOR_MEMBERS_ALICE_NOW_URL = `${HOME_URL}/alice-agora`
export const FOR_MEMBERS_FAMILY_DOCTOR_URL = `${HOME_URL}/medico-de-familia`
export const FOR_COMPANIES_URL = `${HOME_URL}/para-empresas`
export const FOR_DOCTORS_URL = `${HOME_URL}/para-medicos`
export const FOR_BROKERS_URL = `${HOME_URL}/corretores`

/*
 * planos de saude
 */
export const ME_HEALTH_PLAN_URL = 'https://www.alice.com.br/plano-de-saude-me'
export const PJ_HEALTH_PLAN_URL = `${HOME_URL}/plano-de-saude-pj`
export const PME_HEALTH_PLAN_URL = 'https://www.alice.com.br/plano-de-saude-pme'
export const MLA_HEALTH_PLAN_URL =
  'https://www.alice.com.br/plano-de-saude-grandes-empresas'
export const SP_COMPANY_HEALTH_PLAN_URL =
  'https://www.alice.com.br/plano-de-saude-para-empresas-em-sp'
export const PLANS_AND_PRICES_URL = `${HOME_URL}/precos-e-tipos-de-planos-empresariais-alice`

export const PLANS_COMPARISON_PDF_URL =
  'https://s3.amazonaws.com/web.assets.alice.com.br/gas/accredited-establishments/rede_credenciada.pdf'

export const BLOG_URL = 'https://alice.com.br/blog'
export const BLOG_TECH_URL = 'https://alice.com.br/tech'
export const CAREER_URL = 'https://alice.inhire.app/vagas'
export const FREQUENTLY_ASKED_QUESTIONS_URL =
  'https://alice.com.br/perguntas-frequentes'
export const SUCCESS_CASES_URL = 'https://alice.com.br/cases-de-sucesso'
export const SUCCESS_CASE_GABRIEL_URL =
  'https://alice.com.br/case-de-sucesso/medicos-especialistas-que-fazem-a-diferenca-como-a-vida-da-familia-de-um-colaborador-da-gabriel-mudou-com-a-alice'
export const SUCCESS_CASE_ZIG =
  'https://alice.com.br/case-de-sucesso/como-a-alice-ajuda-a-zig-a-cuidar-da-saude-de-um-time-espalhado-por-117-cidades-do-brasil'

export const TERM_OF_USE_URL = 'https://alice.com.br/termos-de-uso/geral'
export const PRIVACY_POLICY_URL = 'https://alice.com.br/politica-de-privacidade'
export const INSTITUTIONAL_URL = 'https://alice.com.br/institucional'
export const MANIFESTO_URL = `${HOME_URL}/alice-manifesto`
export const OMBUDSMAN_URL = 'https://ouvidoria.alice.com.br/hc/pt-br'
export const COSTUMER_CARE_URL = 'https://canalconfidencial.com.br/alice'

export const LINKEDIN_URL = 'https://www.linkedin.com/company/alice'
export const INSTAGRAM_URL = 'https://www.instagram.com/alicesaude'
export const YOUTUBE_URL = 'https://www.youtube.com/c/AliceSa%C3%BAde'
